import React from 'react'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import vThum from '../assests/vission.png'
import mThum from '../assests/mission.png'

export default function VisionandMission() {
    return (
        <section className="relative bg-gradient-to-r from-[#011F41] to-[#011F41] py-16 px-4 overflow-hidden">

            {/* Background Glow */}
            {/* <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/20 blur-3xl rounded-full"></div> */}

            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className='p-7 rounded-[0px] text-white bg-[#011F41]/20 'style={{borderLeft:'5px solid #ddd'}}>
                    <img src={mThum} alt='' />
                    <h3 className='text-3xl font-bold pb-4 pt-3'>Our Mission</h3>
                    <p className='text-gray-300 leading-8'>To reimagine lending through smart automation and secure infrastructure. We help institutions deliver faster, reliable, and efficient credit experiences with reduced manual effort.</p>
                </div>
                <div className='p-7 rounded-[0px] text-white 'style={{borderLeft:'5px solid #ddd'}}>
                    <img src={vThum} alt='' />
                    <h3 className='text-3xl font-bold pb-4'>Our Vision</h3>
                    <p className='text-white-300 leading-8'>To create a future where credit is fast, fair, and fully digital. We envision seamless, user-driven lending experiences powered by AI, trusted by users, and accessible anytime, anywhere.</p>
                </div>
            </div>
        </section>
    )
}
